import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/components/new',
    name: 'components.new',
    component: () => import('./views/ComponentCreate'),
    meta: {
      auth: true
    }
  },
  {
    path: '/components/:uuid',
    name: 'components.edit',
    component: () => import('./views/ComponentEdit'),
    meta: {
      auth: true
    }
  },
  {
    path: '/components',
    name: 'components',
    component: () => import('./views/ComponentList'),
    meta: {
      auth: true
    }
  }
])
